interface ChevronIconProps {
    direction?: 'up' | 'down' | 'left' | 'right';
    className?: string;
}

export default function ChevronIcon({ direction = 'down', className = '' }: ChevronIconProps) {
    const getRotation = () => {
        switch (direction) {
            case 'up':
                return 'rotate-180';
            case 'left':
                return 'rotate-90';
            case 'right':
                return '-rotate-90';
            case 'down':
            default:
                return '';
        }
    };

    return (
        <svg
            className={`transition-transform ${getRotation()} ${className || 'w-8 h-8'}`}
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M36 18L24 30L12 18"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
